<template>
  <iframe
    :id="'guidle_iframe-' + guidleId"
    :data-src="src"
    allowtransparency
    scrolling="no"
    frameborder="0"
    height="400"
    :name="'guidle_iframe-' + guidleId"
    style="width: 1px; min-width: 100%"
    @load="onLoad"
  />
</template>

<script setup lang="ts">
// @ts-ignore
import jQuery from 'jquery'
// @ts-ignore
window.jQuery = jQuery
// @ts-ignore
window.$ = jQuery

const props = defineProps<{
  guidleId: string
}>()

const SCRIPT_POSTMESSAGE =
  'https://www.guidle.com/js/jquery.ba-postmessage.min.js'
const SCRIPT_GUIDLE =
  'https://www.guidle.com/hosted/template_portal/microsite/static/js/micrositeContainerModule.js'

const language = useCurrentLanguage()

const isReady = ref(false)

useScript({
  src: SCRIPT_POSTMESSAGE,
  async: true,
  defer: true,
  crossorigin: false,
})

useScript({
  src: SCRIPT_GUIDLE,
  async: true,
  defer: true,
  crossorigin: false,
})

function onLoad() {}

const src = computed(
  () => `//microsite.guidle.com/${language.value}/mr_${props.guidleId}`,
)

onMounted(() => {
  isReady.value = true
})
</script>
